export const contactRoomId = function (a, b) {
  return `${location.hostname}_${[a,b].sort((a,b)=>a-b).join('&') }`;
}
export const contactRequestCompanyInfoRoomId = function (a,b) {
  return {[contactRoomId(a, b)]:{unReadNum:0}}
}
export const contactRequestCompanyInfoRoomIdArrayToObject = (a=-1,b=[])=>{
  return b.map(item=>{
    return[
      contactRoomId(a,item),
      {unReadNum:0},
    ]
  }).reduce((previousValue, currentValue, currentIndex, array) => {
    return {
      ...previousValue,
      [currentValue[0]]:currentValue[1]
    };
  },{});


}
/*时间统一格式化*/
export const dateFormat = ({create})=>{
  if(!create)return;
  let data = new Date();
  let month = (data.getMonth() + 1) < 10 ? '0' + (data.getMonth() + 1) : data.getMonth() + 1;
  let date = data.getDate() < 10 ? '0' + data.getDate() : data.getDate();
  let hours = data.getHours() < 10 ? '0' + data.getHours() : data.getHours();
  let minute = data.getMinutes() < 10 ? '0' + data.getMinutes() : data.getMinutes();
  let second = data.getSeconds() < 10 ? '0' + data.getSeconds() : data.getSeconds();
  return `${data.getFullYear()}-${month}-${date} ${hours}:${minute}:${second}`;
};
export default {
  methods:{
    contactRoomId,
    contactRequestCompanyInfoRoomId,
  },
}

